<template>
  <select-content-list v-show="show" :disabled="!list_id" :label="label || title" :list_id="list_id" v-model="val" :clearable="clearable" :required="required" :autoselect_first="autoselect_first" :item-text="itemText" :item-value="itemValue" :multiple="multiple"></select-content-list>
</template>

<script>
import SelectContentList from '@/components/SelectContentList'
import {EventMixin} from '@/lib/mixins.js';
import EventModel from '@/models/event.js'
export default {
  mixins: [EventMixin],
  props: [
    'value',
    'label',
    'title',
    'name',
    'content_id',
    'from',
    'from_key',
    'from_get_fun',
    'content_id_get_fun',
    'clearable',
    'required',
    'autoselect_first',
    'item-text',
    'item-value',
    'multiple'
  ],
  components: {
    SelectContentList
  },
  watch: {
    list_id (val) {
      if(!val) this.val = undefined;
    }
  },
  computed: {
    from_data () {
      return _.get(this.value, this.from);
    },
    list_id () {
      if(typeof(this.from_data) == "undefined") {
        if(typeof(this.content_id_get_fun) != "undefined") {
          var content_id = EventModel.exec_content_id_get_fun(this.content_id_get_fun, this.value);
          return (typeof(content_id) != "undefined" ? content_id : this.content_id);
        } else {
          return this.content_id;
        }
      }
      if(typeof(this.from_get_fun) != "undefined") {
        return EventModel.exec_from_get_fun(this.from_get_fun, this.from_data, this.from_key);
      }
      if (typeof(this.from_key) != "undefined") {
        return this.from_data[this.from_key];
      }
      return this.from_data;
    },
    val: {
      get () {
        if(!this.list_id) return undefined;
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
